/** Dictionary key the API sends when the same user signs in on another device. */
export const SESSION_REPLACED_KEY = 'com.tempedge.error.session.replaced';

/** Access token rejected: logged out, same-device close, new IP, stale token, or no session. */
export const SESSION_NOT_VALID_KEY = 'com.tempedge.error.session.notvalid';

/** Refresh grant rejected: expired, malformed, bad signature, or missing refresh scope. */
export const REFRESH_TOKEN_INVALID_KEY = 'com.tempedge.error.session.refreshtokeninvalid';

/** Refresh rejected because the session is inactive (status I) or does not exist. */
export const SESSION_INACTIVE_KEY = 'com.tempedge.error.invaliduser';

export const SESSION_REPLACED_CODE = 'TE-E07';
export const SESSION_NOT_VALID_CODE = 'TE-E09';
export const SESSION_INACTIVE_CODE = 'TE-E02';

const dictionaryKey = (value) => (typeof value === 'string' && value.startsWith('com.tempedge.') ? value : null);

/** Key the backend sends in `errorKey`, or in `message` on older v1 bodies. */
export const sessionErrorKey = (response) => {
  const data = response?.data;
  if (!data) return null;

  return data.errorKey || dictionaryKey(data.message);
};

/**
 * Builds the detector for one session error: it matches the body by its code or by its dictionary key.
 * @param {string} code - Backend error code, e.g. TE-E07.
 * @param {string} key - Dictionary key the backend sends for it.
 * @returns {function(Object): boolean} Predicate over an axios response.
 */
const matchesSessionError = (code, key) => (response) =>
  Boolean(response?.data) && (response.data.code === code || sessionErrorKey(response) === key);

/** Another device took the session. Access calls answer 401; refresh answers 400. Code TE-E07. */
export const isSessionReplacedResponse = matchesSessionError(SESSION_REPLACED_CODE, SESSION_REPLACED_KEY);

/** The access token's session does not match. HTTP 401, code TE-E09. */
export const isSessionNotValidResponse = (response) => sessionErrorKey(response) === SESSION_NOT_VALID_KEY;

/** The refresh token itself cannot be used. HTTP 400, code TE-E09. */
export const isRefreshTokenInvalidResponse = (response) => sessionErrorKey(response) === REFRESH_TOKEN_INVALID_KEY;

/** No active session to refresh. HTTP 400, code TE-E02. */
export const isSessionInactiveResponse = matchesSessionError(SESSION_INACTIVE_CODE, SESSION_INACTIVE_KEY);
